<template>
  <section class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row mb-3">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <div>
            <h4><i class="fas fa-bolt" style="color: #FF6B35;"></i> Try Out Sprint</h4>
            <p class="text-muted mb-0">Latihan intensif jangka pendek untuk persiapan ujian</p>
          </div>
          <router-link to="/ujian" class="btn btn-outline-secondary">
            <i class="fas fa-arrow-left"></i> Kembali
          </router-link>
        </div>
      </div>

      <!-- Info Cards -->
      <div class="row mb-4">
        <div class="col-md-4">
          <div class="card border-0" style="background: linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%); color: white;">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <i class="fas fa-bolt fa-3x mr-3" style="opacity: 0.8;"></i>
                <div>
                  <h5 class="mb-0">Sprint Mode</h5>
                  <small>Ujian cepat dengan durasi terbatas</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card border-0" style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); color: white;">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <i class="fas fa-clock fa-3x mr-3" style="opacity: 0.8;"></i>
                <div>
                  <h5 class="mb-0">Durasi Singkat</h5>
                  <small>30-60 menit per sesi</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card border-0" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <i class="fas fa-chart-line fa-3x mr-3" style="opacity: 0.8;"></i>
                <div>
                  <h5 class="mb-0">Analisis Instan</h5>
                  <small>Hasil & analisis langsung</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="text-center py-5">
        <i class="fas fa-spinner fa-spin fa-3x text-primary"></i>
        <p class="mt-3">Memuat paket Sprint...</p>
      </div>

      <!-- Paket Sprint Grid -->
      <div class="row" v-else>
        <div v-for="paket in sprintList" :key="paket.id" class="col-md-4 col-sm-6 mb-4">
          <div class="card card-sprint h-100" @click="selectPaket(paket)">
            <div class="card-body text-center d-flex flex-column">
              <div class="sprint-icon mb-3">
                <i :class="paket.icon || 'fas fa-bolt'" style="font-size: 48px; color: #FF6B35;"></i>
              </div>
              <h5 class="card-title font-weight-bold">{{ paket.nama_paket }}</h5>
              <p class="text-muted flex-grow-1">{{ paket.deskripsi || 'Paket sprint intensif' }}</p>
              <div class="d-flex justify-content-around mb-3">
                <div class="text-center">
                  <h4 class="mb-0 text-primary">{{ paket.item_paket || 0 }}</h4>
                  <small class="text-muted">Soal</small>
                </div>
                <div class="text-center">
                  <h4 class="mb-0 text-warning">{{ paket.durasi || 30 }}</h4>
                  <small class="text-muted">Menit</small>
                </div>
              </div>
              <button class="btn btn-sprint btn-block">
                <i class="fas fa-play"></i> Mulai Sprint
              </button>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div v-if="sprintList.length === 0" class="col-12 text-center py-5">
          <i class="fas fa-inbox fa-4x text-muted"></i>
          <h5 class="mt-3 text-muted">Belum ada paket Sprint tersedia</h5>
          <p class="text-muted">Silakan hubungi admin untuk membuat paket Sprint</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authFetch } from "@/libs/hxcore";
import Swal from "sweetalert2";

export default {
  name: "UjianSprint",
  data() {
    return {
      loading: true,
      sprintList: [],
    };
  },
  created() {
    this.loadSprint();
  },
  methods: {
    loadSprint() {
      authFetch("/siswa/ujian/list_sprint")
        .then(res => res.json())
        .then(json => {
          this.loading = false;
          if (json.success) {
            this.sprintList = json.data.data || json.data || [];
            this.sprintList = this.sprintList.map(p => ({
              ...p,
              icon: this.getIcon(p.type_name || p.nama_paket),
            }));
          }
        })
        .catch(() => {
          this.loading = false;
          // Fallback to empty if loading failed
          this.sprintList = [];
        });
    },
    getIcon(name) {
      if (!name) return 'fas fa-bolt';
      const n = name.toLowerCase();
      if (n.includes('skd')) return 'fas fa-cubes';
      if (n.includes('tpa')) return 'fas fa-brain';
      if (n.includes('polri')) return 'fas fa-shield-alt';
      if (n.includes('sprint')) return 'fas fa-bolt';
      return 'fas fa-file-alt';
    },
    selectPaket(paket) {
      this.$router.push('/ujian-mapel-list/' + paket.id + '/ujian/online');
    },
  },
};
</script>

<style scoped>
.card-sprint {
  border: 2px solid #FF6B35;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}
.card-sprint:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 35px rgba(255, 107, 53, 0.35);
  border-color: #FF8E53;
}
.btn-sprint {
  background: linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  padding: 10px;
  transition: all 0.3s;
}
.btn-sprint:hover {
  background: linear-gradient(135deg, #FF8E53 0%, #FF6B35 100%);
  color: white;
  transform: scale(1.02);
}
.sprint-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 107, 53, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
</style>
